import { CollapsibleSection } from '../CollapsibleSection';
import { ParamTable } from '../ParamTable';

type QuerySegmentParams = {
  segmentName: string;
  content: string[] | undefined;
};

export const QueryParamsSegment = ({ segmentName, content }: QuerySegmentParams) => {
  return (
    <>
      {content && content.length > 0 && (
        <CollapsibleSection
          closeAltText={`Hide query params segment`}
          expandAltText={`Show query params segment`}
          toExpand={
            <ParamTable resources={content.map((value) => ({ value: value }))} />
          }
          disable={content.length === 0}
          shouldIndent={content.length > 0}
          className="-mb-[1px] mt-1 flex w-full overflow-hidden border-b border-borderMuted p-4"
        >
          <span>
            <p className="mx-2 align-middle text-base font-semibold">{segmentName}</p>
          </span>
        </CollapsibleSection>
      )}
    </>
  );
};
